// pb-korting.js: Probio Noord klantkorting helper
// Wordt geladen door snippets/pb-klantkorting-data.liquid (die window.PBNiveau zet).
// Gelijk aan de automatische kortingen in Shopify: categorie op EXACT product-type
// (regels van de slimme collecties korting-reiniging, korting-papier-dispensers,
// korting-schoonmaakmateriaal, korting-afval-bescherming). Het merk telt niet mee.
(function(){
  var niveau = window.PBNiveau || '';
  var tabel = {
    reiniging: {brons:10, zilver:15, goud:20, diamant:25, platinum:30},
    papier:    {brons:2,  zilver:5,  goud:7,  diamant:10, platinum:12},
    materiaal: {brons:5,  zilver:7,  goud:10, diamant:13, platinum:16},
    afval:     {brons:0,  zilver:3,  goud:5,  diamant:7,  platinum:9}
  };
  var types = {
    reiniging: ['Allesreiniger','Allesreinigers','Afwasmiddel','Vaatwas','Industriereiniger','Desinfectiemiddelen','Desinfectie','Glasreinigers','Glasreiniger','Handzeep','Interieurreiniger','Keuken & horeca reiniging','Keukenreiniger','Luchtverfrissers','Luchtverfrisser','Ontstopper','Reinigingsmiddelen','Sanitairreinigers','Sanitairreiniger','Vaatwasreiniger','Vloerreiniger','Vloerreinigers','Wasmiddel','Wasmiddelen','Zeep & handdesinfectie'],
    papier:    ['Toiletpapier','Handdoekpapier','Poetspapier','Poetsrollen & industriedoeken','Papierdispensers','Dispensers','Zeepdispensers','Keukenbenodigdheden'],
    materiaal: ['Poetsdoeken','Doeken & sponzen','Microvezeldoek','Moppen & dweilen','Bezems & borstels','Stelen & accessoires','Spratflacon','Emmer','Emmers & werkwagens','Werkwagen','Stofzuigers & accessoires','Stofzuigers','Stofzuigerzakken','Stofzuigerzakken & accessoires','Glasbewassing','Vloerpads','Sanitair accessoires'],
    afval:     ['Afvalzakken','Afvalbakken','Handschoenen','Persoonlijke verzorging','Hoge Werkschoenen','Lage Werkschoenen','Polo','Softshell','T-Shirt','Trui','Vest','Werkbroek']
  };

  window.PBKorting = {
    niveau: niveau,
    pct: function(type, vendor) {
      if(!niveau) return 0;
      for (var groep in types) {
        if (types[groep].indexOf(type) > -1) return tabel[groep][niveau] || 0;
      }
      return 0;
    }
  };
})();